import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ISplugDefinition } from 'core/api';
import { filterAllTruthyInTuple } from 'core/rx-js';
import { SplugConfigService } from 'core/splug';
import { Subject, combineLatest, map } from 'rxjs';
import { SignatureOptionsService } from '../signature-options.service';

@Component({
  selector: 'ss-allowed-signature-types-checklist',
  templateUrl: './allowed-signature-types-checklist.component.html',
  styleUrls: ['./allowed-signature-types-checklist.component.css'],
  host: {
    class: 'flex-column gap-small'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AllowedSignatureTypesChecklistComponent implements OnInit {

  private readonly _destroy = new Subject<void>()
  readonly allowedSignatureTypesSubject = this._signatureOptionsService.allowedSignatureTypesSubject;
  readonly setUpSignatureTypesObs = this._signatureOptionsService.setUpSignatureTypesObs;

  readonly splugDefinitionsSubject = this._splugConfigService.splugDefinitionsSubject;



  readonly signatureTypeDataSourceObs = combineLatest([
    this.splugDefinitionsSubject,
    this.setUpSignatureTypesObs
  ])
    .pipe(

      filterAllTruthyInTuple(),
      map(([splugDefinitions, setUpSignatureTypes]) =>
        splugDefinitions.filter((splugDefinition) => !splugDefinition.controls || setUpSignatureTypes.includes(splugDefinition.id))
      ),
    )

  readonly noSplugsCofiguredObs = this.signatureTypeDataSourceObs.pipe(
    map((definedSignatures) => !Boolean(definedSignatures.length))
  )

  constructor(
    private readonly _signatureOptionsService: SignatureOptionsService,
    private readonly _splugConfigService: SplugConfigService
  ) {

  }

  ngOnInit(): void {

  }

  splugChecked(evParams: any, splugDefinition: ISplugDefinition) {

    const { checked } = evParams;


    const newAllowedSignatures = this.allowedSignatureTypesSubject.value || [];

    const typeIdx = newAllowedSignatures.indexOf(splugDefinition.id);

    if (checked && typeIdx < 0) {
      newAllowedSignatures.push(splugDefinition.id)
    }
    else if (!checked && typeIdx >= 0) {

      newAllowedSignatures.splice(typeIdx, 1);
    }

    this.allowedSignatureTypesSubject.next([...newAllowedSignatures])
  }

  configureSplugs() {
    this._signatureOptionsService.openActorConfig();
  }

  // trackSplugByType(type: SignatureType) {

  //   return type;
  // }



  ngOnDestroy() {
    this._destroy.next()
    this._destroy.complete()
  }
}
